import type { Alert } from '@api/api/event-alerts';

export const getAlfredRequestId = (alertEvent: Alert) => {
  const payload = alertEvent.metadata?.payload;
  return payload && 'request_id' in payload ? payload.request_id : undefined;
};
